const modulo = (n, d) => ((n % d) + d) % d;

export default {
    nextAvailableDelivery: function (todayParam, dateParam) {
        let today = todayParam || new Date();
        let date = dateParam || new Date();
        date.setUTCHours(0, 0, 0, 0);

        let dayOfWeek = modulo(date.getUTCDay() - 1, 7);
        let workday = Math.min(dayOfWeek, 4);

        let nextDelivery = today.getHours() >= 16 || dayOfWeek >= 5
            ? (workday + 3) % 5
            : (workday + 2) % 5;

        while (modulo((date.getUTCDay() - 1), 7) !== nextDelivery)
            date.setDate(date.getDate() + 1);

        return date;
    }
}
